import {
  POST_REGISTER_VALIDATE_REQUEST,
  POST_REGISTER_VALIDATE_SUCCESS,
  POST_REGISTER_VALIDATE_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POST_REGISTER_VALIDATE_REQUEST:
      return { ...initialState, isLoading: true };
    case POST_REGISTER_VALIDATE_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case POST_REGISTER_VALIDATE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
